<template>
  <div>
    <Subheader title="Staff Reports" />

    <div class="app-content-column">
      <div class="is-centered">
        <button class="large-button" @click="exportData('/projects/export-all/')">
          Download Project Reports
        </button>
      </div>
      <div class="is-centered">
        <button class="large-button" @click="exportData('/goals/export-all/')">
          Download Goal Reports
        </button>
      </div>
      <div class="is-centered">
        <button class="large-button" @click="exportData('/users/export-all/')">
          Download User Reports
        </button>
      </div>
      <div class="is-centered">
        <button class="large-button" @click="exportData('/payments/export-all/')">
          Download Payment Reports
        </button>
      </div>
      <div class="is-centered">
        <button class="large-button" @click="exportData('/payouts/export-all/')">
          Download Payout Reports
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Report from '@/services/reports'

export default {
  name: 'StaffActivatorOverview',
  components: {
    Subheader,
  },
  data() {
    return {}
  },
  methods: {
    exportData(exportURL) {
      Report.api
        .retrieveExport(exportURL)
        .then(() => {
          this.$Alert.alert({
            type: 'success',
            message: `Export Successful`,
            timeout: 6000,
          })
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'error',
            message: `Export Failed`,
            timeout: 6000,
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/mixins/tables';
@import '../styles/mixins/popup';
@import '../styles/forms';

.is-centered {
  display: flex;
  justify-content: center;
}
</style>
